export default "__VITE_ASSET__C9i$uUft__"